//import { MoneyLinkException } from "@/shared/utils/custom-exception";
import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { PostOcrAccountsService } from "@/features/accounts/ocr/services/post-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { usePostOcrAccountStates } from "@/features/accounts/ocr/hooks/use-post-accounts-states";
import { useContext } from "react";


export const usePostOcrAccount = () => {
  const {
    passbookName,
    setPassbookName,
    isShowErrorDialog,
    setIsShowErrorDialog,
  } = usePostOcrAccountStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const postOcrAccountsService = new PostOcrAccountsService();

  // 口座名登録イベント
  const onPassbookName = (value: string) => {
    setPassbookName(value.trim());
  };

  /*--------------------
    イベント関連
  --------------------*/
  // OCR口座登録
  const registerOcrAccounts = async (
    accountGroupId: string,
    passbookName: string,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await postOcrAccountsService.postOcrAccounts({
        account_group_id: accountGroupId,
        passbook_name: passbookName,
      });
      return res.ocr_account_id ?? "";
    } catch (error) {
      // エラーハンドリング
      console.log("registerOcrAccounts", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }

    // ファイルアップロードがあるのならこの後にOCR明細取込処理？
  };

  return {
    passbookName,
    setPassbookName,
    onPassbookName,
    isShowErrorDialog,
    setIsShowErrorDialog,
    registerOcrAccounts: errorHandledAsync(registerOcrAccounts, setError),
  };
};
